module.exports = __webpack_public_path__ + "img/cplus_small.292b4549.png";